<template>
<CContainer>
    <CRow>
        <CCol col="12" class="d-flex overflow-auto px-0">
            <CreateBtn v-if="$policy('media').create" :to="{name: 'media.create'}" class="mfe-2"/>
            <FilterIt class="mfe-2" />
            <SortIt class="mr-auto" />
        </CCol>
    </CRow>

    <Table class="mt-2" v-if="$policy('media').create_any_or_group" />
    <Grid v-else class="mt-2" />
</CContainer>
</template>

<script>
import { FilterIt, Table, Grid, SortIt } from './partials'

export default {
    name: 'Media',

    components: {
        FilterIt,
        SortIt,
        Table,
        Grid,
    },
}
</script>
